import { baseurl } from "../../BaseUrl";
import axios from "axios";

export const createFloorApi = async (data) => {
  try {
    const res = await axios.post(`${baseurl}/floors/createFloor`, data);
    return { isError: false, data: res.data };
  } catch (e) {
    return { isError: true, data: e.response.data.message };
  }
};

export const updateFloorApi = async (id, data) => {
  try {
    const res = await axios.put(`${baseurl}/floors/editFloor/${id}`, data);
    return { isError: false, data: res.data };
  } catch (e) {
    return { isError: true, data: e.response.data.message };
  }
};

export const getFloorsApi = async (id) => {
  try {
    const res = await axios.get(
      `${baseurl}/floors/get-floors-by-restaurant/${id}`
    );
    return { isError: false, data: res.data };
  } catch (e) {
    return { isError: true, data: e.response.data.message };
  }
};
